import type { AddToBagInput, CustomizationMachineInput } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const getAddToBagInput: CustomizationMachineInput<AddToBagInput> = (args) => {
  const { product, quantity, modifications, mixedDressingDetails } = args.context;

  return {
    product,
    quantity,
    additions: modifications?.additions ?? [],
    removals: modifications?.removals ?? [],
    substitutions: modifications?.substitutions ?? [],
    mixedDressingDetails,
  };
};
